import React, { useState, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import { FaCalendar } from "react-icons/fa6";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import { getAllUsers, getSelfUser } from "../../../config/LiveApi";

function HeaderTableComplaint({
  setParentStartDate,
  setParentEndDate,
  setParentUserId,
  currentPage,
}) {
  const [merchantNames, setMerchantNames] = useState([]);
  const [showPicker, setShowPicker] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const MerchantOptions = merchantNames.map((merch) => ({
    value: merch?.id,
    label: merch?.alias ? merch?.alias : merch?.id,
  }));
  const handleMerchChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedMerchant(null);
      setParentUserId(null); // 🔥 clear filter
      return;
    }

    setSelectedMerchant({
      name: selectedOption.label,
      value: selectedOption.value,
    });

    setParentUserId(selectedOption.value); // 🔥 SEND USER ID
  };

  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  });
  const token = useSelector((store) => store.userReducer.token);
  let role = useSelector((store) => store.userReducer.role);
  const [minDate, setMinDate] = useState(null);

  const customDate = () => {
    setShowPicker(!showPicker);
  };

  const handleSelect = (ranges) => {
    setState({ ...state, selection: ranges.selection });

    const startDate = new Date(ranges.selection.startDate);
    const endDate = new Date(ranges.selection.endDate);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    setStartDate(startDate);
    setEndDate(endDate);
  };
  const handleApply = () => {
    if (!startDate || !endDate) return;

    setParentStartDate(startDate);
    setParentEndDate(endDate);
    setShowPicker(false);
  };

  const handleClear = (e) => {
    e.preventDefault();
    setShowPicker(false);

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    setState({
      selection: {
        startDate: todayStart,
        endDate: todayEnd,
        key: "selection",
      },
    });

    setStartDate(todayStart);
    setEndDate(todayEnd);

    setParentStartDate(todayStart);
    setParentEndDate(todayEnd);
  };

  useEffect(() => {
    const fetchMinDate = async () => {
    if (role === "admin" || role === "super" || role === "subSuper") {

      const response = await getSelfUser(token);

      setMinDate(new Date(response.createdAt));
    }
    };

    fetchMinDate();
  }, []);

  useEffect(() => {
    const fetchMerchNames = async () => {
      try {
        if(role === "admin" || role === "subAdmin") return;
        const response = await getAllUsers(token, 1);
        const filteredData = await response.data.filter((merchant) => {
          return merchant.role === "admin";
        });
        setMerchantNames(filteredData);
        setSelectedMerchant(null);
      } catch (error) {
        console.error("Error fetching merchants:", error);
      }
    };

    fetchMerchNames();
  }, [token]);
  return (
    <div className="recon-header complaint-header">
      <div className="complaint-header-left">
        <h2 className="area-top-management">Complaints Table</h2>

        {(role !== "admin" && role !== "subAdmin") && (
          <ReactSelect
            className="merchant-filter"
            classNamePrefix="react-select"
            value={
              selectedMerchant
                ? {
                    value: selectedMerchant.value,
                    label: selectedMerchant.name,
                  }
                : null
            }
            options={MerchantOptions}
            onChange={handleMerchChange}
            placeholder="Select Merchant"
            isClearable
          />
        )}
      </div>

      <div className="header-box-cal">
        <div className="dash-head">
          <div className="pay-in-out-div">
            <p onClick={() => customDate()}>Select date range:</p>
            <div
              className={showPicker ? "selected-filter" : "filter-on-chart"}
              onClick={() => customDate()}
            >
              <FaCalendar size={20} />
            </div>
          </div>
        </div>
        <div>
          {state.selection.startDate && state.selection.endDate && (
            <p style={{ marginLeft: "12px" }}>
              {state.selection.startDate && state.selection.endDate && (
                <span className="selectedOrg">
                  {new Date(state.selection.startDate).toLocaleDateString()} -{" "}
                  {new Date(state.selection.endDate).toLocaleDateString()}
                </span>
              )}
            </p>
          )}
        </div>

        {showPicker && (
          <div className="picker-box">
            <div className="date-range-picker-container">
              <DateRangePicker
                ranges={[state.selection]}
                onChange={(e) => handleSelect(e)}
                minDate={minDate}
                maxDate={new Date()}
              />
              <div className="recon-date-btn">
                <button
                  onClick={(e) => handleClear(e)}
                  className="clear-button"
                >
                  Clear
                </button>
                <button onClick={handleApply} className="apply-button">
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeaderTableComplaint;
